import { useSearchParams } from 'next/navigation';

import { useUserState } from '@/hooks/store';

export function useFreeTrial() {
	const user = useUserState();
	const searchParams = useSearchParams();

	const isSecondFreeTrial = searchParams?.get('focus') === 'second_free_trial';

	if (user?.subscription?.valid) {
		return false;
	}
	if (isSecondFreeTrial) {
		return true;
	}
	if (user?.subscription?.has_ever_done_free_trial) {
		return false;
	}
	return true;
}
